export const GET_STATES = "GET_STATES";
export const GET_LIST_STATES = "GET_LIST_STATES";
export const GET_STATE = "GET_STATE";
export const SET_STATES = "SET_STATES";
export const SET_LIST_STATES = "SET_LIST_STATES";
export const SET_STATE = "SET_STATE";
export const ADD_STATE = "ADD_STATE";
export const SET_NEW_STATE = "SET_NEW_STATE";
export const EDIT_STATE = "EDIT_STATE";
export const SET_EDIT_STATE = "SET_EDIT_STATE";
export const SET_DELETE_STATE = "SET_DELETE_STATE";
export const SET_DELETE_MULTI_STATE = "SET_DELETE_MULTI_STATE";
export const DELETE_STATE = "DELETE_STATE";
export const DELETE_MULTI_STATE = "DELETE_MULTI_STATE";
export const RESET_LIST_STATES = "RESET_LIST_STATES";
export const RESET_ITEMS_STATE = "RESET_ITEMS_STATE";
export const RESET_SELECTED_STATE = "RESET_SELECTED_STATE";
